// Carregar e validar as variáveis de ambiente
const N8N_WEBHOOK_URL = import.meta.env.VITE_WEBHOOK_URL;
const N8N_WEBHOOK_URL_TEST = import.meta.env.VITE_WEBHOOK_URL_TESTE;

// Validar se as URLs estão definidas
if (!N8N_WEBHOOK_URL || !N8N_WEBHOOK_URL_TEST) {
    console.error('❌ Erro: URLs dos webhooks não definidas!', {
        VITE_WEBHOOK_URL: N8N_WEBHOOK_URL,
        VITE_WEBHOOK_URL_TESTE: N8N_WEBHOOK_URL_TEST,
        env: import.meta.env
    });
}

export const n8nApi = {
    // Enviar mensagem para um contato
    sendMessage: async (contact) => {
        try {
            // Forçar uso da URL de produção
            const webhookUrl = N8N_WEBHOOK_URL;

            // Validar URL
            if (!webhookUrl) {
                throw new Error('URL do webhook não configurada! Verifique as variáveis de ambiente.');
            }

            console.log('🚀 Enviando mensagem para webhook:', webhookUrl);
            console.log('📦 Payload:', contact);

            const response = await fetch(webhookUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(contact)
            });

            console.log('📡 Status da resposta:', response.status);
            
            // Se o status HTTP for 200, consideramos sucesso
            return {
                success: response.status === 200
            };
        } catch (error) {
            console.error('❌ Erro ao enviar mensagem:', error);
            throw error;
        }
    }
};
